// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"1a650e50","80":"98dced4c","116":"0ccc138d","127":"3eeb2a11","161":"c0f24655","195":"53431f1f","417":"ca2b419d","469":"230532b1","501":"72ec76f2","506":"2343f431","797":"272405b5","854":"c2b21b20","858":"2986c759"}[chunkId] + ".chunk.js";
};